import numberUtils from 'app-lib/numberUtils'
import { links } from 'bzx-common/src/config/appConfig'
import { Button, Icon, Tooltip } from 'bzx-common/src/ui-framework'
import { observer } from 'mobx-react'
import React, { CSSProperties } from 'react'
import { Link } from 'react-router-dom'
import CircleLoader from 'shared-components/CircleLoader'
import ExternalLink from 'shared-components/ExternalLink'
import OokiDetailsVM from './OokiDetailsVM'

const styles: Record<string, CSSProperties> = {
  totalSupply: { paddingTop: '3px' }, // compensate for coingecko icon
}
const loader = (
  <CircleLoader style={{ width: '16px', height: '16px', display: 'inline-block', top: '2px' }} />
)

export function OokiDetails({ vm }: { vm: OokiDetailsVM }) {
  const tooltip = React.useRef(null)
  const { userWallet } = vm.rootStore
  const { addOokiToken, canAddToken, marketData, ookiBalance } = vm
  return (
    <>
      <div
        className="btn-menu-square"
        data-tip
        data-for="ookiToken"
        data-event="click focus"
        onClick={vm.getData}>
        <Icon name="token-ooki" size={24} />
      </div>
      <Tooltip
        id="ookiToken"
        className="header-dropdown panel--simple flex-col padded-15"
        place={'bottom'}
        clickable={true}
        effect="solid"
        isCapture={true}
        globalEventOff="click"
        data-event-off="click"
        ref={tooltip}
        delayHide={200}>
        <Link to="/stake" className="btn btn--menu">
          <Icon name="Stake-OOKI" size={24} className="margin-right-05" />
          Stake ooki
        </Link>
        <Link to="/dashboard/our-token" className="btn btn--menu">
          <Icon name="About-OOKI" size={24} className="margin-right-05" /> About Ooki Token
        </Link>
        {canAddToken && (
          <Button title="Add OOKI token to Wallet" className="btn btn--menu" onClick={addOokiToken}>
            <Icon name="Add-OOKI" size={24} className="margin-right-05" /> Add ooki to Wallet
          </Button>
        )}
        <hr className="content-separator margin-top-05"></hr>

        <div className="padded-1 txt-explanation">
          {marketData.error && (
            <div className="note--warning padded-1 margin-bottom-1">
              Ooki market data unavailable
            </div>
          )}
          {marketData.value && (
            <div className="flex-between">
              <div>
                <p className="txt-subtitle margin-bottom-05">
                  Price{' '}
                  <ExternalLink href={links.ookiCoingecko}>
                    <Icon name="coingecko" size={24} />
                  </ExternalLink>
                </p>
                $
                <b title={marketData.value.price.toString()}>
                  {numberUtils.autoFormat(marketData.value.price)}
                </b>
                <p className={`txt-${marketData.value.priceChange > 0 ? 'positive' : 'negative'}`}>
                  {numberUtils.autoFormat(marketData.value.priceChange, undefined, { sign: true })}%
                </p>
              </div>
              <div className="txt-right">
                <p className="txt-subtitle margin-bottom-05" style={styles.totalSupply}>
                  Total Supply
                </p>
                <b title={marketData.value.totalSupply.toString()}>
                  {numberUtils.abbreviate(marketData.value.totalSupply)}
                </b>{' '}
                OOKI
              </div>
            </div>
          )}
          {canAddToken && ookiBalance && (
            <p className="txt-subtitle margin-bottom-05">Wallet balance</p>
          )}
          <div className="flex-between">
            {canAddToken && ookiBalance && (
              <div>
                {userWallet.getBalancesPending && ookiBalance.isZero() ? (
                  loader
                ) : (
                  <b title={ookiBalance.toFixed()}>{numberUtils.autoFormat(ookiBalance)}</b>
                )}{' '}
                OOKI
              </div>
            )}

            <div className="txt-right">
              <ExternalLink className="link--discreet" href={links.buyOoki.binance.url}>
                Buy OOKI
              </ExternalLink>
            </div>
          </div>
        </div>
      </Tooltip>
    </>
  )
}

export default observer(OokiDetails)
